import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { PaymentSearchCriteria, SearchResults } from "../model/common.model";

export type PaymentMethod = {
  name: string;
  logo: string;
};

export const PaymentMethods: PaymentMethod[] = [
  { name: "American Express", logo: "american-express" },
  { name: "Apple Pay", logo: "apple-pay" },
  { name: "Mastercard", logo: "master-card" },
  { name: "Visa", logo: "visa" }
];



@Injectable({
  providedIn: "root"
})
export class PaymentService {
  constructor(private http: HttpClient) { }

  get(id: string) {
    return firstValueFrom(this.http.get(`/api/payment/get/${id}`));
  }

  search(criteria: PaymentSearchCriteria, from: number, limit: number) {
    return firstValueFrom(this.http.post<SearchResults<any>>(`/api/payment/search`, criteria, { params: { from, limit } }));
  }
}
